module.exports = __webpack_public_path__ + "static/media/blocker.90780824.svg";